export const CartTotals_SetLoading = 'CartTotals_SetLoading';
export const CartTotals_SetData = 'CartTotals_SetData';
export const CartTotals_SetError = 'CartTotals_SetError';
export const CartTotals_Reset = 'CartTotals_Reset';
export const CartTotals_Abort = 'CartTotals_Abort';
